export const site = {
  siteUrl: "https://cleanout.info",
  businessName: "Professional Property Cleanout LLC",
  shortName: "Professional Property Cleanout",
  phone: "(920) 737-2910",
  tel: "+19207372910",
  email: "propertypro920@yahoo.com",
  city: "De Pere",
  region: "WI",
  postalCode: "54115",
  foundingYear: "2018",
  ownerName: "Chris Potter",
  googleMapsUrl: "https://www.google.com/maps/place/Professional+Property+Cleanout+LLC/@44.3365884,-89.3153641,9z/data=!4m16!1m9!3m8!1s0x8802fbd68d717511:0xc3ef492372070c2d!2sProfessional+Property+Cleanout+LLC!8m2!3d44.338485!4d-88.6559744!9m1!1b1!16s%2Fg%2F11fn1s64pb!3m5!1s0x8802fbd68d717511:0xc3ef492372070c2d!8m2!3d44.338485!4d-88.6559744!16s%2Fg%2F11fn1s64pb",
  serviceAreas: [
    "De Pere", "Green Bay", "Ashwaubenon", "Howard", "Suamico", "Allouez", "Bellevue",
    "Wrightstown", "Kaukauna", "Little Chute", "Appleton", "Neenah", "Menasha", "Oshkosh",
    "Fond du Lac", "Manitowoc", "Sheboygan", "Oconto Falls", "Pulaski", "Seymour", "New London",
    "Waupaca", "Sturgeon Bay",
  ],
} as const;

export const telephoneHref = `tel:${site.tel}`;
export const businessId = `${site.siteUrl}/#business`;
export const socialImageUrl = `${site.siteUrl}/images/social-share.jpg`;